import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { t, lang } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/auth/forgot-password", { email, lang }); setSent(true); }
    catch { toast.error(t({ en: "Please enter a valid email address.", fr: "Veuillez entrer une adresse courriel valide." })); }
    finally { setLoading(false); }
  };
  return (
    <div className="max-w-md mx-auto px-4 py-16 lg:py-24" data-testid="forgot-password-page">
      <div className="overline mb-4">{t({ en: "Password help", fr: "Aide mot de passe" })}</div>
      <h1 className="font-serif text-4xl mb-6 tracking-tight" style={{ color: "var(--ink)" }}>{t({ en: "Reset your password.", fr: "Réinitialiser votre mot de passe." })}</h1>
      {sent ? (
        <p className="text-base" style={{ color: "var(--ink-2)" }} data-testid="forgot-password-sent">
          {t({ en: "If an account exists for that email, a reset link is on its way. Check your inbox (and spam folder). The link expires in one hour.", fr: "Si un compte existe pour ce courriel, un lien de réinitialisation est en route. Vérifiez votre boîte de réception (et les indésirables). Le lien expire dans une heure." })}
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm" style={{ color: "var(--ink-2)" }}>{t({ en: "Enter the email you sign in with and we'll send you a link to choose a new password.", fr: "Entrez le courriel utilisé pour vous connecter et nous vous enverrons un lien pour choisir un nouveau mot de passe." })}</p>
          <input type="email" required autoCapitalize="none" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t({ en: "Email", fr: "Courriel" })} className="w-full p-3 rounded-lg border" style={{ borderColor: "var(--border-medium)", background: "var(--surface)" }} data-testid="forgot-password-email" />
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="forgot-password-submit">
            {loading ? t({ en: "Sending…", fr: "Envoi…" }) : t({ en: "Send reset link", fr: "Envoyer le lien" })}
          </button>
        </form>
      )}
      <p className="mt-6 text-sm"><Link to="/login" className="link-underline" data-testid="forgot-back-to-login">{t({ en: "Back to sign in", fr: "Retour à la connexion" })}</Link></p>
    </div>
  );
}
